import React, { useEffect, useState } from 'react';

// Define the headers list
const tableHeaders = [
    'Building Site',
    'Device ID',
    'Created',
    'Type',
    'Scheduled',
    'Assigned to',
    'WD#',
    'Item Number',
    'Item Priority',
    'Edit Item'
];

const ItemFields = [
    { key: 'buildingSite', label: 'Building Site', type: 'text' },
    { key: 'itemNumber', label: 'Item Number', type: 'text' },
    { key: 'deviceID', label: 'Device ID', type: 'text' },
    { key: 'created', label: 'Created', type: 'date' },
    { key: 'typeName', label: 'Type', type: 'text' },
    { key: 'scheduled', label: 'Scheduled', type: 'date' },
    { key: 'assignedTo', label: 'Assigned to', type: 'text' },
    { key: 'wdnumber', label: 'WD#', type: 'text' },
    { key: 'itemPriority', label: 'Item Priority', type: 'text' }
];

const ActionItemsEntry = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [formData, setFormData] = useState({});
    const [lookupItemNumber, setLookupItemNumber] = useState('');
    const [actionItemsData, setActionItemsData] = useState([]);
    const [isEditing, setIsEditing] = useState(false); // State to track editing

    const formatDateTimeLocal = (dateString) => {
        const date = new Date(dateString);
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const addItem = async () => {
        try {
            const response = await fetch('http://localhost:8080/api/callcenter/actionitems/add', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });
            if (!response.ok) {
                throw new Error("Failed to add item");
            }
            alert("Add Successful");
            toggleModal();
            fetchAllActionItems();
        } catch (error) {
            console.error("Submit Error: ", error);
        }
    };

    const editItem = async () => {
        try {
            const response = await fetch(`http://localhost:8080/api/callcenter/actionitems/${lookupItemNumber}`, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData),
            });
            if (!response.ok) {
                throw new Error("Failed to edit item");
            }
            alert("Update Successful");
            toggleModal();
            fetchAllActionItems();
        } catch (error) {
            alert("Edit Failed (Make sure the item number is correct in lookup)")
            console.error("Edit Error: ", error);
        }
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (isEditing) {
            editItem();
        } else {
            addItem();
        }
    };

    const handleDelete = async () => {
        try {
            console.log(lookupItemNumber);

            const response = await fetch(`http://localhost:8080/api/callcenter/actionitems/${formData.itemNumber}`, {
                method: 'DELETE',
            });
            if (!response.ok) {
                throw new Error("Failed to delete item");
            }
            fetchAllActionItems();
            toggleModal();
        } catch (error) {
            alert("Item Number Not Found!!")
            console.error("Lookup Error: ", error);
        }
    }

    const handleLookup = async () => {
        try {
            console.log(lookupItemNumber);

            const response = await fetch(`http://localhost:8080/api/callcenter/actionitems/${lookupItemNumber}`);
            if (!response.ok) {
                throw new Error("Item not found");
            }
            const data = await response.json();
            const formattedData = {
                ...data,
                created: data.created ? formatDateTimeLocal(data.created) : '',
                scheduled: data.scheduled ? formatDateTimeLocal(data.scheduled) : '',
            };
            setFormData(formattedData);
        } catch (error) {
            alert("Item Number Not Found!!")
            console.error("Lookup Error: ", error);
        }
    };

    const fetchAllActionItems = async () => {
        try {
            const response = await fetch('http://localhost:8080/api/callcenter/actionitems');

            if (!response.ok) {
                throw new Error("Failed to fetch items");
            }
            const data = await response.json();
            const formattedData = data.map(item => ({
                ...item,
                created: item.created ? formatDateTimeLocal(item.created) : '',
                scheduled: item.scheduled ? formatDateTimeLocal(item.scheduled) : '',
            }));

            setActionItemsData(formattedData);
            console.log("This is the action items data: " + (actionItemsData));

            return data;
        } catch (error) {
            console.error("Fetch Error: ", error);
            return [];
        }
    }

    useEffect(() => {
        fetchAllActionItems();
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        console.log(name);
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const toggleModal = () => {
        setIsModalOpen(!isModalOpen);
    };

    const openFormForEdit = (item) => {
        setFormData({
            ...item,
            created: item.created ? formatDateTimeLocal(item.created) : '',
            scheduled: item.scheduled ? formatDateTimeLocal(item.scheduled) : '',
        });


        setLookupItemNumber(item.itemNumber); // Assuming 'id' is the unique identifier
        setIsEditing(true);
        toggleModal();
    };

    const openFormForAdd = () => {
        setFormData({});
        setIsEditing(false);
        toggleModal();
    };

    return (
        <div className="mx-auto h-screen w-full">
            <div className="flex justify-between items-center p-3 mb-4">
                <div className="flex justify-start items-center">
                    <h2 className="mr-10 text-2xl font-bold">Action Items Entry</h2>
                </div>
                <div className="flex space-x-1 items-center">
                    <button
                        className="border border-sss-accent-yel bg-sss-accent-yel rounded-lg px-5 py-2 flex text-sss-blue-sel font-bold
                        hover:bg-yellow-500 transition duration-300 ease-in-out"
                        onClick={openFormForAdd}
                    >
                        Add +
                    </button>
                </div>
            </div>
            <div className="overflow-x-auto overflow-y-auto p-5 flex items-center">
                <table className="min-w-full bg-white rounded-lg shadow-lg overflow-hidden border-2 border-gray-200">
                    <thead className="bg-gray-200">
                        <tr>
                            {tableHeaders.map((field) => (
                                <th key={field} className="px-4 py-2 text-left font-semibold text-gray-600">
                                    {field}
                                </th>
                            ))}
                        </tr>
                    </thead>
                    <tbody className="text-gray-700">
                        {actionItemsData.map((job, index) => (
                            <tr key={index} className="border-t hover:bg-sss-accent-yel">
                                <td className="px-4 py-2">{job.buildingSite}</td>
                                <td className="px-4 py-2">{job.deviceID}</td>
                                <td className="px-4 py-2">{job.created}</td>
                                <td className="px-4 py-2">{job.typeName}</td>
                                <td className="px-4 py-2">{job.scheduled}</td>
                                <td className="px-4 py-2">{job.assignedTo}</td>
                                <td className="px-4 py-2">{job.wdnumber}</td>
                                <td className='px-4 py-2'>{job.itemNumber}</td>
                                <td className='px-4 py-2'>{job.itemPriority}</td>
                                <td className="px-4 py-2">
                                    <button
                                        className="text-blue-500 py-2 px-4 rounded"
                                        onClick={() => openFormForEdit(job)}
                                    >
                                        Edit
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            {isModalOpen && (
                <div className="fixed inset-0 flex items-center justify-center z-50">
                    <div className="fixed inset-0 bg-black opacity-50"></div>
                    <div className="bg-white p-6 rounded-lg shadow-lg z-10 max-h-screen overflow-y-auto">
                        <h2 className="text-2xl font-bold mb-4">{isEditing ? 'Edit Item' : 'Add Item'}</h2>
                        <div className='space-y-4'>
                            <form onSubmit={handleSubmit}>
                                <div className="grid grid-cols-2 gap-4">
                                    {ItemFields.map((field) => (
                                        <div key={field.key} className="mb-4">
                                            <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor={field.key}>
                                                {field.label}
                                            </label>
                                            {field.key === 'itemPriority' ? (
                                                <select
                                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                                    id={field.key}
                                                    name={field.key}
                                                    value={formData[field.key] || ''}
                                                    onChange={handleChange}
                                                    required
                                                >
                                                    <option value="">Select Priority</option>
                                                    <option value="Low">Low</option>
                                                    <option value="Medium">Medium</option>
                                                    <option value="High">High</option>
                                                    <option value="Critical">Critical</option>
                                                </select>
                                            ) : (
                                                <input
                                                    className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                                    id={field.key}
                                                    name={field.key}
                                                    type={field.type}
                                                    value={formData[field.key] || ''}
                                                    onChange={handleChange}
                                                    disabled={isEditing && field.key === 'itemNumber'}
                                                    required
                                                />
                                            )}
                                        </div>
                                    ))}
                                </div>
                                {isEditing && (
                                    <div className="mb-4">
                                        <label className="block text-gray-700 text-sm font-bold mb-2" htmlFor="lookupItemNumber">
                                            Lookup Item Number
                                        </label>
                                        <div className="flex">
                                            <input
                                                className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline"
                                                id="lookupItemNumber"
                                                type="text"
                                                placeholder="Enter Item Number to Lookup"
                                                value={lookupItemNumber}
                                                onChange={(e) => setLookupItemNumber(e.target.value)}
                                            />
                                            <button
                                                type="button"
                                                className="ml-2 bg-sss-accent-yel text-sss-blue-sel font-bold py-2 px-4 rounded hover:bg-yellow-500 transition duration-300 ease-in-out"
                                                onClick={handleLookup}
                                            >
                                                Lookup
                                            </button>
                                        </div>
                                    </div>
                                )}
                                <div className="flex justify-end">
                                    <button
                                        type="submit"
                                        className="bg-sss-accent-yel text-sss-blue-sel font-bold py-2 px-4 rounded hover:bg-yellow-500 transition duration-300 ease-in-out"
                                    >
                                        {isEditing ? 'Update' : 'Add'}
                                    </button>
                                    <button
                                        type="button"
                                        className="ml-2 bg-gray-300 text-gray-700 font-bold py-2 px-4 rounded hover:bg-gray-400 transition duration-300 ease-in-out"
                                        onClick={toggleModal}
                                    >
                                        Close
                                    </button>
                                    {isEditing && (
                                        <button
                                            type="button"
                                            className="ml-2 border border-red-500 bg-red-500 rounded px-5 py-2 text-white font-bold
                        hover:bg-red-700 transition duration-300 ease-in-out"
                                            onClick={handleDelete}
                                        >
                                            Delete
                                        </button>
                                    )}
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ActionItemsEntry;